import { insightOpportunityCopy as copy } from '@testfeed/product-language'
import * as z from 'zod'
import { definePage } from '../page-declaration'
import type { usePageLifecycle } from '../hooks/usePageLifecycle'
import { storeResearchCardsSchema } from '@testfeed/shopify-contracts'

/** Independent source lifecycle: an analytical readiness failure must not hide research, or vice versa. */
export const researchCardsPage = definePage({
  name: 'insights',
  sources: { researchCards: { required: true, check: storeResearchCardsSchema } },
  actions: {},
})

/** Query owns scope/display validation; this source checks its lifecycle projection, not analytical facts. */
export const page = definePage({
  name: 'insights',
  sources: {
    insights: {
      required: true,
      check: z.object({ state: z.enum(['ready', 'unavailable', 'not_started', 'preparing', 'blocked', 'failed']) }),
      isReady: (data: { state: string }) => data.state === 'ready' || data.state === 'unavailable',
    },
  },
  actions: {
    'test-setup': {
      saves: false,
      interaction: { textEditing: 'block' },
      feedback: { failure: copy.seedFailed },
    },
  },
})

export type InsightsLifecycle = ReturnType<typeof usePageLifecycle<typeof page>>
